// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2NGko","content":"styles_content__34HtY","selectAll":"styles_selectAll__13PDN"};